/**
 * StickerMedias 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { StickerMediaItem } from './sticker_media_item'

/**
 * StickerMedias
 */
export interface StickerMedias {
  /** 预览图（静态） */
  preview?: StickerMediaItem
  /** GIF格式 */
  gif?: StickerMediaItem
  /** MP4视频格式 */
  mp4?: StickerMediaItem
  /** WebM视频格式 */
  webm?: StickerMediaItem
  /** 缩略图 */
  thumbnail?: StickerMediaItem
}

/**
 * StickerMedias Schema
 */
export const StickerMediasSchema: SchemaDefinition = {
  properties: {
    preview: {
      $ref: 'StickerMediaItem',
      description: '预览图（静态）',
      label: '预览图',
    },
    gif: {
      $ref: 'StickerMediaItem',
      description: 'GIF格式',
      label: 'GIF格式',
    },
    mp4: {
      $ref: 'StickerMediaItem',
      description: 'MP4视频格式',
      label: 'MP4视频格式',
    },
    webm: {
      $ref: 'StickerMediaItem',
      description: 'WebM视频格式',
      label: 'WebM视频格式',
    },
    thumbnail: {
      $ref: 'StickerMediaItem',
      description: '缩略图',
      label: '缩略图',
    },
  },
  type: 'object',
}
